<template>
    <div class="Ajapp" :style="{ '--divWidth--': divWidth, '--divHeight--': divHeight, }" style="width: var(--divWidth--);height: var(--divHeight--);top: 0;left: 0;z-index: 1 !important;
background-repeat:no-repeat;background-size: var(--divWidth--)  var(--divHeight--);overflow: hidden;">
        <div class="ajMain">
            <div class="leftDiv">
                <div style="position: relative;width: 100%;top: 10%;height: 100%;" v-if="prizeMsg[itemIndex]">
                    <div style="width:100%;color: white;text-align: center;display: flex;">
                        <div v-if="prizeMsg[itemIndex].piName" :style="{ 'fontSize': nowSize(40) + 'px', }"
                            style="width:80%;color: #FFF2CC;">{{ prizeMsg[itemIndex].piName }}</div>
                        <div style="width: 10%;position: relative;right: 20%;bottom: -2%;"
                            :style="{ 'fontSize': nowSize(20) + 'px' }">
                            <div> <i class="el-icon-caret-top" style="color: #FFF2CC;" @click="topIndex"></i></div>
                            <div> <i class="el-icon-caret-bottom" style="color: #FFF2CC;" @click="DownIndex"></i> </div>
                        </div>
                    </div>
                    <div style="width: 80%;height: 40%;margin: 3%;">
                        <el-image style="width: 100%; height: 75%" v-if="prizeMsg[itemIndex].piImage"
                            :src="prizeMsg[itemIndex].piImage">
                        </el-image>
                        <div style="width: 100%;text-align: center;color: white;"
                            :style="{ 'fontSize': nowSize(23) + 'px', }">数量:{{ prizeMsg[itemIndex].piNum }}</div>
                    </div>
                    <div style="width: 80%;height: 15%;margin: 3%;color: white;text-align: center;overflow: hidden;"
                        :style="{ 'fontSize': nowSize(20) + 'px', }">
                        {{ prizeMsg[itemIndex].piNamePrize }}
                    </div>
                    <div style="width: 80%;height: 15%;margin: 3%;color: white;text-align: center;overflow: hidden;"
                        :style="{ 'fontSize': nowSize(20) + 'px', }">
                        <div style="width: 90%;margin: 2% auto;height: 45%;background-color: rgba(255, 255,255,0.4);text-align: center;padding: 3%;"
                            :style="{ 'fontSize': nowSize(23) + 'px', }">
                            参与人数:{{ itemDetail.pmuNums }}
                        </div>
                        <div style="width: 90%;margin: 2% auto;height: 45%;background-color: rgba(255, 255,255,0.4);text-align: center;padding: 3%;"
                            :style="{ 'fontSize': nowSize(23) + 'px', }">
                            奖品总数:{{ prizeMsg[itemIndex].piNum }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="centenDiv">
                <div
                    style="width: 100%;height: 80%;display: flex;padding: 5%;justify-content: space-around;flex-wrap: wrap;align-items: center;">
                    <template v-if="IsPrize">
                        <div style="height: 37%;position: relative;margin: 1%;"
                            :style="{ 'width': nowSize(160) + 'px', }" v-for="(item, index) in activityUser"
                            :key="item.pmuId"
                            v-show="index >= currentIndex && index <= (currentIndex + (prizeMsg[itemIndex].piNum >= 10 ? 10 : prizeMsg[itemIndex].piNum) - 1)">
                            <div class="handImg" style="border-radius: 100%;overflow: hidden;"
                                :style="{ 'width': nowSize(160) + 'px', 'height': nowSize(160) + 'px' }">
                                <img v-if="item.pmuHeader" :src="item.pmuHeader" alt=""
                                    style="width: 100%;height: 100%;">
                                <div v-else
                                    style="width: 100%;height: 100%;border-radius: 100%;background-color: #489EE2;display: flex;align-items: center;">
                                    <div style="text-align: center;width: 100%;color: aliceblue;"
                                        :style="{ 'fontSize': nowSize(25) + 'px', }">
                                        {{ item.pmuName }}
                                    </div>
                                </div>
                            </div>
                            <div class="handImgto"
                                :style="{ 'width': nowSize(160) + 'px', 'height': nowSize(160) + 'px' }">
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div style="height: 37%;position: relative;margin: 1%;"
                            :style="{ 'width': nowSize(160) + 'px', }" v-for="(item, index) in userMoke" :key="index"
                            v-show="index >= currentIndex && index <= (currentIndex + (prizeMsg[itemIndex].piNum >= 10 ? 10 : prizeMsg[itemIndex].piNum) - 1)">
                            <div class="handImg" style="border-radius: 100%;overflow: hidden;"
                                :style="{ 'width': nowSize(160) + 'px', 'height': nowSize(160) + 'px' }"
                                v-if="item.pmuHeader">
                                <img :src="item.pmuHeader" alt="" style="width: 100%;height: 100%;">
                            </div>
                            <div class="handImgto"
                                :style="{ 'width': nowSize(160) + 'px', 'height': nowSize(160) + 'px' }"
                                v-if="item.pmuHeader">
                            </div>
                        </div>
                    </template>

                </div>
                <div style="width: 30%;margin: 2% auto;height: 10%;" v-if="!IsPrize" @click="KaiShiClick">
                    <img style="width: 100%; height: 100%" src="../../assets/img/kaishi.png" />
                </div>
                <div style="width: 30%;margin: 2% auto;height: 10%;" v-else @click="TingZhiClick">
                    <img style="width: 100%; height: 100%" src="../../assets/img/tz.png" />
                </div>
            </div>
            <div class="rightDiv">
                <div style="width: 95%;height:100%;padding: 3%;">
                    <div style="width: 100%;height: 7%;border-bottom: 1px solid white;text-align: center;color: white;margin-top: 6%;padding:2%"
                        :style="{ 'fontSize': nowSize(23) + 'px', }" @click="IsUserDia = true">
                        名单:{{ activityUserZJ.length || '0' }}人
                    </div>
                    <div class="diaZj"
                        style="width: 100%;height: 82%;overflow-y: auto;overflow-x: hidden;margin-top: 3%;padding: 2%;"
                        v-if="activityUserZJ.length > 0">
                        <div style="display: flex;width: 100%;align-items: center;margin: 2% 0;"
                            :style="{ 'height': nowSize(80) + 'px' }" v-for="(item, index) in activityUserZJ || []"
                            :key="index">
                            <div style="overflow: hidden;border-radius: 100%;"
                                :style="{ 'height': nowSize(80) + 'px', 'width': nowSize(80) + 'px', }">
                                <img v-if="item.pmuHeader" :src="item.pmuHeader" alt=""
                                    style="width: 100%;height: 100%;">
                                <div v-else
                                    style="width: 100%;height: 100%;border-radius: 100%;background-color: #489EE2;display: flex;align-items: center;">
                                    <div style="text-align: center;width: 100%;color: aliceblue;"
                                        :style="{ 'fontSize': nowSize(16) + 'px', }">
                                        {{ item.pmuName }}
                                    </div>
                                </div>

                            </div>
                            <div style="margin-left: 5%;color: white;" :style="{ 'fontSize': nowSize(20) + 'px', }">
                                {{ item.pmuName }}
                            </div>
                        </div>

                    </div>
                    <div style="width: 100%;height:82%;display:flex;align-items: center;justify-content: center;"
                        v-else>
                        <div style="color: white;" :style="{ 'fontSize': nowSize(23) + 'px', }">暂未开奖</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="diaBg"
            style="width: 100%;height: 100%;position: fixed;top: 0;left: 0;background-color: rgba(11, 2, 2, 0.5);"
            v-if="IsUserDia">
            <div class="diaBg2" style="width: 85%;height: 85%;margin: 5% auto;overflow: hidden;">
                <div style="width: 100%;text-align: center;color: white;margin: 2%;"
                    :style="{ 'fontSize': nowSize(40) + 'px', }">
                    中奖人员
                </div>
                <div class="diaZj"
                    style="width: 100%;overflow-y: auto;height: 68%;display: flex;flex-wrap: wrap;align-items: center;padding:2% 5%;justify-content: space-around;">
                    <div style="height: 45%;position: relative;margin: 1%;" :style="{ 'width': nowSize(160) + 'px', }"
                        v-for="(item, index) in activityUserZJ || []" :key="index">
                        <div class="handImg" style="border-radius: 100%;overflow: hidden;"
                            :style="{ 'width': nowSize(160) + 'px', 'height': nowSize(160) + 'px' }">
                            <img v-if="item.pmuHeader" :src="item.pmuHeader" alt="" style="width: 100%;height: 100%;">
                            <div v-else
                                style="width: 100%;height: 100%;border-radius: 100%;background-color: #489EE2;display: flex;align-items: center;">
                                <div style="text-align: center;width: 100%;color: aliceblue;"
                                    :style="{ 'fontSize': nowSize(28) + 'px', }">
                                    {{ item.pmuName }}
                                </div>
                            </div>

                        </div>
                        <div class="handImgto" :style="{ 'width': nowSize(160) + 'px', 'height': nowSize(160) + 'px' }">
                        </div>
                        <div style="text-align: center;color: white;" :style="{ 'fontSize': nowSize(24) + 'px', }">
                            {{ item.pmuName }}</div>
                    </div>

                </div>
                <div
                    style="width: 30%;margin: 1% auto;height: 8%;display: flex;align-items: center;justify-content: center;">
                    <!-- <img style="width: 100%; height: 100%" src="../../assets/img/kaishi.png" @click="ZjClose" /> -->
                    <el-button round style="background-color: rgba(11, 2, 2, 0.5);color: #FFF2CC;"
                        @click="ZjClose">关闭</el-button>
                </div>
            </div>
            <!-- <div class="diaBg2" style="width: 85%;height: 80%;margin: 5% auto;overflow: hidden;" v-else>
                <div style="width: 60%;height: 50%;margin: 15% auto;">
                   <img :src="bg" alt="">
                </div>
            </div> -->
        </div>
        <audio ref="audioPlayer" :src="audio" @ended="onAudioEnd"></audio>
        <div class="admin" style="position: fixed;top: 2%;width: 15%;" :style="{ 'right': '-' + nowSize(190) + 'px', }">
            <el-button round style="background-color: rgba(11, 2, 2, 0.5);"
                :style="{ 'marginLeft': nowSize(60) + 'px', }" @click="goToAdmin">活动管理</el-button>
        </div>
    </div>
</template>
<script>
import request from "../../../request";
import {
    getPzItemList, getPzItemDetails, getPzItemPrizeUserList, getPzItemPrize, getPzItemRecordList,
} from "../../api/api";
export default {
    name: 'HomePage',
    components: {

    },
    data() {

        return {
            audio:require('../../assets/img/1.mp3'),
            bg: require('../../assets/img/1.gif'),
            IsWin: false,//获奖
            timerId: '',
            IsPrize: false,
            userMoke: [],
            currentIndex: 0,//当前抽奖用户下标
            activityUserZJ: [],//中奖用户
            activityUser: [],//抽奖用户
            itemIndex: 0,
            itemDetail: '',//当前奖项的详情
            prizeMsg: '',//活动奖项信息
            IsUserDia: false,//中奖名单弹框
            divWidth: '100%',
            divHeight: '100%',
        }
    },
    computed: {

    },
    watch: {},
    activated() {

    },
    created() {
        document.title = '深圳傲举年会抽奖';
        console.log(this.$route.query.pmId)
        this.pmId = this.$route.query.pmId
        if (this.$route.query.pmId) {
            getPzItemList({ pmId: this.$route.query.pmId }).then(res => {
                this.prizeMsg = res.data;
                console.log(this.prizeMsg);
                getPzItemDetails({ piId: res.data[this.itemIndex].piId }).then(res => {
                    this.itemDetail = res.data
                    console.log(this.itemDetail);
                });
                getPzItemPrizeUserList({ piId: res.data[this.itemIndex].piId, pmId: this.$route.query.pmId }).then(res => {
                    this.activityUser = res.data;
                    this.userMoke = [];
                    for (var i = 0; i < this.prizeMsg[this.itemIndex].piNum; i++) {
                        const s = {
                            pmuHeader: require('../../assets/img/hand.png')
                        }
                        this.userMoke.push(s)
                    }
                    console.log(this.userMoke);

                });
                this.getPzItemRecordList_api()
            })
        }

    },
    methods: {
        playAudio() {
            const audio = this.$refs.audioPlayer;
            audio.play().catch(err => {
                console.error(err);
            });
        },
        stopAudio() {
            const audio = this.$refs.audioPlayer;
            audio.pause();
            audio.currentTime = 0;
        },
        onAudioEnd() {
            console.log('音频播放结束');
        },
        ZjClose() {
            this.IsUserDia = false;
            this.IsWin = false;
            this.getDetail();
        },
        getPzItemRecordList_api() {
            getPzItemRecordList({ piId: this.prizeMsg[this.itemIndex].piId, pmId: this.pmId }).then(res => {
                this.activityUserZJ = res.data
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "抽奖中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        getDetail() {
            getPzItemDetails({ piId: this.prizeMsg[this.itemIndex].piId }).then(res => {
                this.itemDetail = res.data;
                getPzItemPrizeUserList({ piId: this.prizeMsg[this.itemIndex].piId, pmId: this.pmId }).then(ress => {
                    this.activityUser = ress.data;
                    this.userMoke = [];
                    for (var i = 0; i < this.prizeMsg[this.itemIndex].piNum; i++) {
                        const s = {
                            pmuHeader: require('../../assets/img/hand.png')
                        }
                        this.userMoke.push(s)
                    }
                });
            })
        },
        KaiShiClick() {
            if (this.itemDetail.pmuNums <= 0) {
                this.$message({
                    type: "danger",
                    message: "没有用户可以中奖了!",
                });
                return;
            }
            if (this.itemDetail.piStatus == 1) {
                this.playAudio()
                this.IsPrize = true;
                this.startScrolling();
            } else {
                this.$message({
                    type: "danger",
                    message: "该奖项已被抽取过!",
                });
            }

        },
        TingZhiClick() {
            this.openLoading()
            this.IsPrize = false;
            this.IsUserDia = true;
            clearInterval(this.timerId);
            this.currentIndex = 0;
            getPzItemPrize({ piId: this.prizeMsg[this.itemIndex].piId }).then(res => {
                if (res.status == 200) {
                    this.loadings.close();
                    this.activityUserZJ = res.data;
                    this.IsWin = true;
                    this.stopAudio()
                }
            })
        },
        startScrolling() {
            this.timerId = setInterval(() => {
                this.currentIndex++;
                const piNum = this.prizeMsg[this.itemIndex].piNum >= 10 ? 10 : this.prizeMsg[this.itemIndex].piNum
                if (this.prizeMsg[this.itemIndex].piNum === 1) {
                    if (this.currentIndex === this.activityUser.length) {

                        this.currentIndex = 0;
                    }
                } else {
                    if (this.currentIndex === piNum) {

                        this.currentIndex = 0;
                    }
                }

            }, 200); // 调整间隔时间以达到所需速度
        },
        topIndex() {
            if (this.itemIndex == 0) {

            } else {
                this.currentIndex = 0
                this.itemIndex = this.itemIndex - 1;
                this.IsPrize = false;
                clearInterval(this.timerId);
                getPzItemDetails({ piId: this.prizeMsg[this.itemIndex].piId }).then(res => {
                    this.itemDetail = res.data;
                    getPzItemPrizeUserList({ piId: this.prizeMsg[this.itemIndex].piId, pmId: this.pmId }).then(res => {
                        this.activityUser = res.data;
                        this.userMoke = [];
                        for (var i = 0; i < this.prizeMsg[this.itemIndex].piNum; i++) {
                            const s = {
                                pmuHeader: require('../../assets/img/hand.png')
                            }
                            this.userMoke.push(s)
                        }
                    });
                    this.getPzItemRecordList_api()
                })

            }
        },
        DownIndex() {
            if (this.itemIndex == this.prizeMsg.length - 1) {
                this.$message({
                    type: "danger",
                    message: "已经是最后一个奖项了!",
                });
            } else {
                this.currentIndex = 0
                this.itemIndex = this.itemIndex + 1;
                this.IsPrize = false;
                clearInterval(this.timerId);
                getPzItemDetails({ piId: this.prizeMsg[this.itemIndex].piId }).then(res => {
                    this.itemDetail = res.data;
                    getPzItemPrizeUserList({ piId: this.prizeMsg[this.itemIndex].piId, pmId: this.pmId }).then(res => {
                        this.activityUser = res.data;
                        for (var i = 0; i < this.prizeMsg[this.itemIndex].piNum; i++) {
                            const s = {
                                pmuHeader: require('../../assets/img/hand.png')
                            }
                            this.userMoke.push(s)
                        }
                    });
                })
                this.getPzItemRecordList_api()
            }
        },
        // 返回活动管理
        goToAdmin() {
            this.$router.replace('/Home')
        },
        //  换算方法
        nowSize(val, initWidth = 1920) {
            //当前视口宽度
            let nowClientWidth = document.documentElement.clientWidth;
            return val * (nowClientWidth / initWidth);
        }
    }
}
</script>

<style scoped>
.diaZj::-webkit-scrollbar {
    display: none;
}

.admin:hover {
    right: 1% !important;
    width: auto !important;
}

.diaBg {
    background-image: url(../../assets/img2026/bg33.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.diaBg2 {
    background-image: url(../../assets/img/mingdanBg.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.Ajapp {
    background-image: url(../../assets/img2026/bg33.png) !important;
}

.ajMain {
    display: flex;
    height: 80%;
    width: 90%;
    justify-content: space-between;
    margin: 8% auto;
    overflow: hidden;
}

.leftDiv {
    width: 25%;
    background-image: url(../../assets/img/left.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.centenDiv {
    width: 75%;
    background-image: url(../../assets/img/mingdanBg.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.rightDiv {
    width: 18%;
    margin-left: 2%;
    background-image: url(../../assets/img/right.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.handImg {
    background-image: url(../../assets/img/hand.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
}

.handImgto {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    width: 100%;
    height: 100%;
    background: url(../../assets/img/headquan.png) no-repeat !important;
    background-size: 100% 100% !important;
    -webkit-animation: rotateAnimation 2.5s infinite linear;
    animation: rotateAnimation 2.5s infinite linear;
    transform-origin: center !important;
}

@keyframes rotateAnimation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }


}
</style>
